import React, { useState } from 'react';
import Modal from 'react-modal';
import './gallery.css'; // Custom styling
import ILimage1 from '../../Images/Akb-images/GalleryImages/IndustryLeader/1.jpg'
import ILimage2 from '../../Images/Akb-images/GalleryImages/IndustryLeader/2.JPG'
import ILimage3 from '../../Images/Akb-images/GalleryImages/IndustryLeader/3.jpg'
import ILimage4 from '../../Images/Akb-images/GalleryImages/IndustryLeader/4.jpg'
import ILimage5 from '../../Images/Akb-images/GalleryImages/IndustryLeader/5.JPG'
import ILimage6 from '../../Images/Akb-images/GalleryImages/IndustryLeader/6.jpg'
import ILimage7 from '../../Images/Akb-images/GalleryImages/IndustryLeader/7.JPG'
import ILimage8 from '../../Images/Akb-images/GalleryImages/IndustryLeader/8.JPG'
import ILimage9 from '../../Images/Akb-images/GalleryImages/IndustryLeader/9.jpg'
import ILimage10 from '../../Images/Akb-images/GalleryImages/IndustryLeader/10.jpg'
import ILimage11 from '../../Images/Akb-images/GalleryImages/IndustryLeader/11.jpg'

// Achivements Images
import ACimage1 from '../../Images/Akb-images/GalleryImages/Achivements/1.jpg'
import ACimage2 from '../../Images/Akb-images/GalleryImages/Achivements/2.JPG'
import ACimage3 from '../../Images/Akb-images/GalleryImages/Achivements/3.jpg'
import ACimage4 from '../../Images/Akb-images/GalleryImages/Achivements/4.jpg'
import ACimage6 from '../../Images/Akb-images/GalleryImages/Achivements/6.JPG'
import ACimage8 from '../../Images/Akb-images/GalleryImages/Achivements/8.jpg'
import ACimage9 from '../../Images/Akb-images/GalleryImages/Achivements/9.jpg'
import ACimage10 from '../../Images/Akb-images/GalleryImages/Achivements/10.jpg'
import ACimage11 from '../../Images/Akb-images/GalleryImages/Achivements/11.jpg'
import ACimage12 from '../../Images/Akb-images/GalleryImages/Achivements/12.jpg'

// Students Connect

import SCimage1 from '../../Images/Akb-images/GalleryImages/StudentConnect/1.jpg'
import SCimage2 from '../../Images/Akb-images/GalleryImages/StudentConnect/2.jpg'
import SCimage3 from '../../Images/Akb-images/GalleryImages/StudentConnect/3.jpg'
import SCimage4 from '../../Images/Akb-images/GalleryImages/StudentConnect/4.jpg'
import SCimage5 from '../../Images/Akb-images/GalleryImages/StudentConnect/5.jpg'
import SCimage6 from '../../Images/Akb-images/GalleryImages/StudentConnect/6.jpg'
import SCimage7 from '../../Images/Akb-images/GalleryImages/StudentConnect/7.jpg'
import SCimage8 from '../../Images/Akb-images/GalleryImages/StudentConnect/8.JPG'
import SCimage9 from '../../Images/Akb-images/GalleryImages/StudentConnect/9.jpg'
import SCimage10 from '../../Images/Akb-images/GalleryImages/StudentConnect/10.jpg'
import SCimage11 from '../../Images/Akb-images/GalleryImages/StudentConnect/11.jpg'
import SCimage12 from '../../Images/Akb-images/GalleryImages/StudentConnect/12.jpg'
import SCimage13 from '../../Images/Akb-images/GalleryImages/StudentConnect/13.jpg'
import SCimage14 from '../../Images/Akb-images/GalleryImages/StudentConnect/14.JPG'
import SCimage15 from '../../Images/Akb-images/GalleryImages/StudentConnect/15.jpg'
import SCimage16 from '../../Images/Akb-images/GalleryImages/StudentConnect/16.jpg'

Modal.setAppElement('#root'); // Avoid accessibility warnings

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Categories and images
  const categories = {
    All: [
      ILimage1,ILimage2,ILimage3,ILimage4,ILimage5,ILimage6,ILimage7,ILimage8,ILimage9,ILimage10,ILimage11,
      ACimage1,ACimage2,ACimage3,ACimage4,ACimage6,ACimage8,ACimage9,ACimage10,ACimage11,ACimage12,
      SCimage1,SCimage2,SCimage3,SCimage4,SCimage5,SCimage6,SCimage7,SCimage8,SCimage9,SCimage10,SCimage11,SCimage12,SCimage13,SCimage14,SCimage15,SCimage16,
    ],
    "INDUSTRY LEADER CONNECT": [        
      ILimage1,
      ILimage2,
      ILimage3,
      ILimage4,
      ILimage5,
      ILimage6,
      ILimage7,
      ILimage8,
      ILimage9,
      ILimage10,
      ILimage11,],
    ACHIEVEMENT: [
      ACimage1,
      ACimage2,
      ACimage3,
      ACimage4,
      ACimage6,
      ACimage8,
      ACimage9,
      ACimage10,
      ACimage11,
      ACimage12,
    ],
    "STUDENTS CONNECT": [
      SCimage1,SCimage2,SCimage3,SCimage4,SCimage5,SCimage6,SCimage7,SCimage8,SCimage9,SCimage10,SCimage11,SCimage12,SCimage13,SCimage14,SCimage15,SCimage16,
    ],
  };

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  return (
    <div className="image-gallery mt-4">
      <h1 className="gallery-title">Gallery</h1>

      {/* Category Filter Buttons */}
      <div className="category-buttons">
        {Object.keys(categories).map((category) => (
          <button
            key={category}
            className={`category-button ${
              selectedCategory === category ? 'active' : ''
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Images Grid */}
      <div className="image-grid">
        {categories[selectedCategory].map((image, index) => (
          <img
            key={index}
            src={image}
            alt={selectedCategory}
            className="gallery-image"
            onClick={() => openModal(image)}
          />
        ))}
      </div>

      {/* Modal for selected image */}
      {selectedImage && (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Image Modal"
          className="image-modal"
          overlayClassName="modal-overlay"
        >
          <img src={selectedImage} alt="Selected" className="modal-image" />
          <button className="close-button" onClick={closeModal}>
            ×
          </button>
        </Modal>
      )}
    </div>
  );
};

export default Gallery;
